import { useLocation } from "react-router-dom";
import Layout from "../layouts/LayoutDefault.jsx";
import MakeGetRequest from "../components/utils/MakeGetRequest.jsx";
import AdminView from "../components/band_page/AdminView.jsx";
import MainContainer from "../components/MainContainer.jsx";
import ContentContainer from "../components/ContentContainer.jsx";
import BlogPost from "../components/blog_page/BlogPost.jsx";

const BlogPage = () => {
  // Get the full pathname
  const location = useLocation();
  let pathname = location.pathname;

  // Remove trailing slash if it exists
  if (pathname.endsWith("/")) {
    pathname = pathname.slice(0, -1);
  }
  // Extract the title-slug after 'blog/'
  const titleSlug = pathname.split("/blog/")[1];
  // Fetch Band data
  const { data: postData } = MakeGetRequest({
    route: `get_blogpost?titleslug=${titleSlug}`,
    errorCodeRedirect: 404,
  });

  const editPostUrl = postData
    ? `/userprofile/editpost?slug=${postData.blogpost.slug}`
    : "";

  return (
    <>
      <Layout
        title={postData?.blogpost.title}
        description={`${postData?.blogpost.post_type} av ${postData?.blogpost.posted_by_name} om ${postData?.blogpost.title}`}
      >
        {postData ? (
          <>
            {postData.admin_view && (
              <AdminView
                settingsUrl={editPostUrl}
                isVisible={postData.blogpost.visible}
              />
            )}
            <MainContainer>
              <ContentContainer>
                <BlogPost data={postData} />
              </ContentContainer>
            </MainContainer>
          </>
        ) : (
          <div>
            <h4>Bläddrar i arkiven...</h4>
          </div>
        )}
      </Layout>
    </>
  );
};

export default BlogPage;
